import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

export const filterEstimationFieldsWithoutIdentifier = (
  estimation,
  referenceRow = null,
  newInvestment = false
) => {
  let refPriceIn;
  let estPriceIn;
  let refPriceOut;
  let estPriceOut;

  if (newInvestment) {
    refPriceIn = referenceRow?.price_in_wo_taxes;
    estPriceIn = estimation?.price_in_wo_taxes;
    refPriceOut = referenceRow?.price_out_wo_taxes;
    estPriceOut = estimation?.price_out_wo_taxes;
  } else {
    refPriceIn = referenceRow?.price_in;
    estPriceIn = estimation.price_in;
    refPriceOut = referenceRow?.price;
    estPriceOut = estimation.price;
  }
  return {
    product_id: estimation.product_id,
    retailer_id: estimation.retailer_id,
    area_id: estimation.area_id,
    price: estimation.price,
    price_in: estimation.price_in,
    units: estimation.units,
    units_in: estimation.units_in,
    sales: estimation.sales,
    sales_in: estimation.sales_in,
    margin: estimation.margin,
    cost: estimation.cost,
    uncertainty: estimation.uncertainty,
    elasticity: estimation.elasticity,
    price_catalog: estimation.price_catalog,
    investment:
      estPriceOut < refPriceOut
        ? ((refPriceOut - estPriceOut) * estimation.units).toFixed(0)
        : 0,
    investment_in:
      estPriceIn < refPriceIn
        ? ((refPriceIn - estPriceIn) * estimation.units_in).toFixed(0)
        : 0,
    pct_price_cross: estimation.pct_price_cross,
    n_stores: estimation.n_stores,
    price_out_wo_taxes: estimation.price_out_wo_taxes,
    price_in_wo_taxes: estimation.price_in_wo_taxes,
    retailer_margin: estimation.retailer_margin,
  };
};

export const filterDailyEstimationFieldsWithoutIdentifier = (
  estimation,
  scenarioId
) => {
  return {
    id: estimation.id,
    scenario_id: scenarioId,
    estimation_cycle_id: estimation.estimation_cycle_id,
    event_id: estimation.event_id,
    product_id: estimation.product_id,
    retailer_id: estimation.retailer_id,
    area_id: estimation.area_id,
    price: estimation.price,
    price_in: estimation.price_in,
    units: estimation.units,
    units_in: estimation.units_in,
    sales: estimation.sales,
    sales_in: estimation.sales_in,
    margin: estimation.margin,
    price_catalog: estimation.price_catalog,
    investment: estimation.investment,
    investment_in: estimation.investment_in,
    n_stores: estimation.n_stores,
    price_out_wo_taxes: estimation.price_out_wo_taxes,
    price_in_wo_taxes: estimation.price_in_wo_taxes,
    retailer_margin: estimation.retailer_margin,
  };
};

export const filterEstimationDateFieldsWithoutIdentifier = (estimation) => {
  return {
    product_id: estimation.product_id,
    date: estimation.date,
    retailer_id: estimation.retailer_id,
    area_id: estimation.area_id,
    price: estimation.price,
    price_in: estimation.price_in,
    units: estimation.units,
    units_in: estimation.units_in,
    sales: estimation.sales,
    sales_in: estimation.sales_in,
    margin: estimation.margin,
    cost: estimation.cost,
    uncertainty: estimation.uncertainty,
    elasticity: estimation.elasticity,
    price_catalog: estimation.price_catalog,
    investment: estimation.investment,
    investment_in: estimation.investment_in,
    pct_price_cross: estimation.pct_price_cross,
    n_stores: estimation.n_stores,
    price_out_wo_taxes: estimation.price_out_wo_taxes,
    price_in_wo_taxes: estimation.price_in_wo_taxes,
    retailer_margin: estimation.retailer_margin,
  };
};

export const getEstimations = (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "estimations"),
  };

  return athenaClient(config);
};

export const getEstimationsByCycle = (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "estimations_by_cycle"),
  };

  return athenaClient(config);
};
